import { faX } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import React from 'react';

import IconButton from '~/common/components/Icons/IconButton';

type DrawerProps = Readonly<{
  isOpen: boolean;
  onClose: () => void;
  placement?: 'top' | 'right' | 'bottom' | 'left';
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'full';
  finalFocusRef?: React.RefObject<HTMLElement>;
  sx?: React.CSSProperties;
  children: React.ReactNode;
}>;

const sizes = {
  xs: '20rem',
  sm: '28rem',
  md: '32rem',
  lg: '42rem',
  xl: '56rem',
  full: '100vw',
};

const Drawer = ({
  children,
  isOpen,
  onClose,
  placement,
  finalFocusRef,
  size,
  sx,
  ...props
}: Readonly<DrawerProps>) => {
  function closeHandler() {
    onClose();
    finalFocusRef?.current?.focus();
  }

  return (
    <MuiDrawer
      {...props}
      open={isOpen}
      onClose={closeHandler}
      anchor={placement}
      elevation={4}
      slotProps={{
        backdrop: {
          sx: {
            background: 'transparent',
          },
        },
      }}
      PaperProps={{
        role: 'dialog',
      }}
    >
      <Box
        sx={{
          padding: '1rem 1.5rem',
          position: 'relative',
          width: Object.hasOwn(sizes, size) ? sizes[size] : (size ?? sizes.sm),
        }}
      >
        <IconButton
          icon={<FontAwesomeIcon icon={faX} />}
          variant="ghost"
          aria-label="Close"
          onClick={closeHandler}
          sx={{
            position: 'absolute',
            top: '0.5rem',
            right: '1rem',
          }}
        />
        {children}
      </Box>
    </MuiDrawer>
  );
};

export default Drawer;
